<template>
  <splash></splash>


    <!-- Jobs -->


      <div dir="rtl" class="row" v-show="allProcesses.length">
        <div class="col-lg-12">
          <div class=" ">
            <div class="row d-flex justify-content-between align-items-center mb-3">


            </div>
            <div  >
              <div class="d-flex flex-wrap" style="transition: all ease 500ms;">

                <div v-for="item in table_all_Processes"
                     :key="item"
                     class="card card-body card-panel-box card-process-map-1 border-0 "
                     :style="{
       width: table_all_Processes_floor.filter(ele => ele.parent_id === item.id).length > 0 ? '62vw !important' : ''
     }"
                >
                  <h3 style="font-size: 0.9vw !important;font-weight: 400; width: 9vw;margin-bottom: 0vw;margin-right: 1vw;color: #FFF;">
                    {{ item.title }}
                    <br>
                    کد: {{ item.code }}
                  </h3>
                  <div class="d-flex flex-wrap">
                    <div v-for="(i,index) in item.floors"
                         class="card card-body card-panel-box card-process-map-2 mb-3 border-0 w-auto"
                         :style="{
       width: table_all_Processes_groups.filter(ele => ele.parent_id === i.id).length > 0 ? '60vw !important' : ''
     }"

                    >
                      <h3 style="font-size: 0.9vw !important;font-weight: 400; width: 9vw;margin-bottom: 0vw;margin-right: 1vw;color: #000;">
                        {{ i.title }}</h3>
                      <div class="row">
                        <div v-for="j in i.groups" class="col-lg-6">
                          <div class="card card-body card-panel-box card-process-map-3 border-0">
                            <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 1vw;color: #000;">
                              {{ j.title }}</h3>
                            <div v-for="k in j.processes"
                                 class="card card-body card-panel-box card-process-map-4 mb-3 border-0">
                              <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.8vw;color: #000;">
                                {{ k.title }}</h3>
                              <div class="row">
                                <div v-for="l in k.subProcesses"
                                     class="col-lg-4">
                                  <div class="card card-body card-panel-box card-process-map-5 border-0" style="width: 7vw;">
                                    <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.3vw;color: #000;">
                                      {{ l.title }} </h3>
                                    <br>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <!--            item-->
                <div v-for="item in table_all_Processes_by_group"
                     class="card card-body card-panel-box card-process-map-1 border-0">
                  <h3 style="font-size: 0.9vw !important;font-weight: 400; width: 9vw;margin-bottom: 0vw;margin-right: 1vw;color: #FFF;">
                    {{ item.title }}
                    <br>
                    کد: {{ item.code }}
                  </h3>

                  <div class="row">
                    <div v-for="j in item.groups"
                         class="col-lg-6">
                      <div class="card card-body card-panel-box card-process-map-3 border-0">
                        <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 1vw;color: #000;">
                          {{ j.title }}</h3>
                        <div v-for="k in j.processes"
                             class="card card-body card-panel-box card-process-map-4 mb-3 border-0">
                          <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.8vw;color: #000;">
                            {{ k.title }}</h3>
                          <div class="row">
                            <div v-for="l in k.subProcesses"
                                 class="col-lg-4">
                              <div class="card card-body card-panel-box card-process-map-5 border-0">
                                <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.3vw;color: #000;">
                                  {{ l.title }} </h3>
                                <br>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <!--            item-->

                <!--            item-->
                <div v-for="item in table_all_Processes_by_processes"
                     class="card card-body card-panel-box card-process-map-1 border-0">
                  <h3 style="font-size: 0.9vw !important;font-weight: 400; width: 9vw;margin-bottom: 0vw;margin-right: 1vw;color: #FFF;">
                    {{ item.title }}
                    <br>
                    کد: {{ item.code }}
                  </h3>

                  <div class="row">

                    <div v-for="k in item.processes"
                         class="card card-body card-panel-box card-process-map-4 mb-3 border-0">
                      <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.8vw;color: #000;">
                        {{ k.title }}</h3>
                      <div class="row">
                        <div v-for="l in k.subProcesses"
                             class="col-lg-4">
                          <div class="card card-body card-panel-box card-process-map-5 border-0">
                            <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.3vw;color: #000;">
                              {{ l.title }} </h3>
                            <br>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
                <!--            item-->
                <!--            item-->
                <div v-for="item in table_all_Processes_by_sub_process"
                     class="card card-body card-panel-box card-process-map-1 border-0">
                  <h3 style="font-size: 0.9vw !important;font-weight: 400; width: 9vw;margin-bottom: 0vw;margin-right: 1vw;color: #FFF;">
                    {{ item.title }}
                    <br>
                    کد: {{ item.code }}
                  </h3>

                  <div class="row">


                    <div class="row">
                      <div v-for="l in item.subProcesses" v-show="l.parent_id===item.id"
                           class="col-lg-4">
                        <div class="card card-body card-panel-box card-process-map-5 border-0">
                          <h3 style="font-size: 0.9vw !important;font-weight: 400; margin-bottom: 0vw;margin-right: 0.3vw;color: #000;">
                            {{ l.title }} </h3>
                          <br>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
                <!--            item-->

              </div>
            </div>


          </div>
        </div>
      </div>




</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";

export default {
  name: "process_map",
  components: {Sidebar, Splash},
  data() {
    return {
      //*******************************
      //*******************************
      // todo: for categories *******************************
      // *******************************
      categories: [],
      nameCat: '',
      shortNameCat: '',
      encodingMethodCat: '',
      level_cardid: '',
      title_en: '',
      subLevelsCat1: '',
      subLevelsCat2: '',
      subLevelsCat3: '',
      subLevelsCat4: '',
      sub_id: 0,
      isValueChainCat: false,
      openModalsubLevelsCat: false,
      // todo: for categories *******************************
      //*******************************
      // *******************************
      Error: false,
      ErrorM: '',
      // *******************************
      // *******************************
      // todo: for Processes *******************************
      allProcesses: [],
      searchProcesses: '',
      ProcessesId: '',
      addParentProcesses: false,
      modalTitleEn: false,
      modalTitleFa: false,
      editModal: false,
      deleteModal: false,
      showMore: false,
      title_for_edit: '',
      title_for_edit_fa: '',
      levelSub: '',
      title_for_edit_en: '',
      itemProcesses: [],
      table_all_Processes: [],
      table_all_Processes_floor: [],
      table_all_Processes_groups: [],
      table_all_Processes_process: [],
      table_all_Processes_sub_process: [],

      title_for_edit_fa_processes: '',
      title_for_edit_en_processes: '',
      levelSub_processes: '',
      //*******************************
      table_all_Processes_by_group: [],
      table_all_Processes_groups_by_group: [],
      table_all_Processes_process_by_group: [],
      table_all_Processes_sub_process_by_group: [],
      //*******************************
      table_all_Processes_by_processes: [],
      table_all_Processes_process_by_processes: [],
      table_all_Processes_sub_process_by_processes: [],
      //*******************************
      table_all_Processes_by_sub_process: [],
      table_all_Processes_sub_process_by_sub_process: [],

      is_floor_select: false,
      is_group_select: false,
      is_process_select: false,
      is_sub_process_select: false,


      // todo: for Processes *******************************
      //*******************************
      //*******************************
      openModalsubLevelsCatForIdCard: false,
      subLevelsCat2_id: '',
      subLevelsCat3_id: '',
      subLevelsCat4_id: '',
      //*******************************
      //*******************************

    };
  },
  methods: {

    printMethod() {
      setTimeout(()=>{
        window.print()
      },2000)

    },





    fetchAllProcesses() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/processes/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            if (result.items.length) {
              this.allProcesses.length = 0
              result.items.forEach((ele) => {
                this.allProcesses.push(ele)


              })
            }


          })
          .catch();

      fetch(`${this.base_url}/processes/all_table`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result.items.length) {
              this.table_all_Processes.length = 0
              this.table_all_Processes_groups.length = 0
              this.table_all_Processes_process.length = 0
              this.table_all_Processes_floor.length = 0
              this.table_all_Processes_sub_process.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes.push(ele)

              })
              /*result.groups.forEach((ele) => {
                this.table_all_Processes_groups.push(ele)

              })
              result.process.forEach((ele) => {
                this.table_all_Processes_process.push(ele)

              })
              result.sub_process.forEach((ele) => {
                this.table_all_Processes_sub_process.push(ele)

              })
              result.floor.forEach((ele) => {
                this.table_all_Processes_floor.push(ele)

              })*/
            }


          })
          .catch();
      fetch(`${this.base_url}/processes/all_table_by_group`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result.items.length) {
              this.table_all_Processes_by_group.length = 0
              this.table_all_Processes_groups_by_group.length = 0
              this.table_all_Processes_process_by_group.length = 0
              this.table_all_Processes_sub_process_by_group.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes_by_group.push(ele)

              })
              /* result.groups.forEach((ele) => {
                 this.table_all_Processes_groups_by_group.push(ele)

               })
               result.process.forEach((ele) => {
                 this.table_all_Processes_process_by_group.push(ele)

               })
               result.sub_process.forEach((ele) => {
                 this.table_all_Processes_sub_process_by_group.push(ele)

               })*/

            }


          })
          .catch();
      fetch(`${this.base_url}/processes/all_table_by_process`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result.items.length) {
              this.table_all_Processes_by_processes.length = 0
              this.table_all_Processes_process_by_processes.length = 0
              this.table_all_Processes_sub_process_by_processes.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes_by_processes.push(ele)

              })
           /*   result.process.forEach((ele) => {
                this.table_all_Processes_process_by_processes.push(ele)

              })
              result.sub_process.forEach((ele) => {
                this.table_all_Processes_sub_process_by_processes.push(ele)

              })*/

            }


          })
          .catch();
      fetch(`${this.base_url}/processes/all_table_by_sub_process`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result.items.length) {
              this.table_all_Processes_by_sub_process.length = 0
              this.table_all_Processes_sub_process_by_sub_process.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes_by_sub_process.push(ele)

              })
/*
              result.sub_process.forEach((ele) => {
                this.table_all_Processes_sub_process_by_sub_process.push(ele)

              })*/

            }


          })
          .catch();
    },




    // todo: for categories *******************************
    //*******************************
    //*******************************
  },
  mounted() {
    this.fetchAllProcesses()
    this.printMethod()
  },
  computed: {
    filteredItems() {
      return this.allProcesses.filter(item => {
        if (this.searchProcesses) {
          const titleIncludes = item['title'] && item['title'].includes(this.searchProcesses);
          const categoryIncludes = item['category'].includes(this.searchProcesses);
          const code = item['code'].includes(this.searchProcesses);

          return titleIncludes || categoryIncludes || code;
        } else {
          return true; // در صورتی که searchProcesses خالی باشد، همه موارد نمایش داده شوند.
        }
      });
    },

  }

}
</script>

<style scoped>
.row {
  padding: .5vw;
}

@media print {
  .no-print, .hide {
    display: none;
  }
}


.card-process-map-1 {
  background-color: #3742FA;
  padding: 1vw 0.5vw 1vw 0.5vw;
}

.card-process-map-2 {
  background-color: #5E67FC;
  padding: 0.3vw 1vw 1vw 1vw;
  margin-top: 0.8vw;
  margin-bottom: 0.3vw;
}

.card-process-map-3 {
  background-color: #9095FC;
  padding: 1vw;
  margin-top: 0.3vw;
  margin-bottom: 0.3vw;
}

.card-process-map-4 {
  background-color: #B5B8FC;
  padding: 1vw 1vw 0.3vw 1vw;
  margin-top: 0.3vw;
  margin-bottom: 0.3vw;
}

.card-process-map-5 {
  background-color: #E0E1FF;
  padding: 1vw;
  margin-top: 0.3vw;
  margin-bottom: 0.3vw;
}



</style>